export default __webpack_public_path__ + "static/media/annanovikova.9e54ff7f.jpg";